export default {
  availableWithdrawTypes: [],
  withdrawSortInfo: {},
  isUsePcs: false,
  withdrawName: '',
  PCSI18n: {},
  percentageFee: 0,
  calculatedAmount: 0,
  showFee: false,
}
